// This list is shared by the headers, tenant, AND cache interceptors - entries
// here go out WITHOUT auth headers. Cache-only exclusions belong in
// CacheInterceptor's own cacheSkipList instead.
// Lives in its own module (not index.ts) so interceptors can import it without
// creating a cycle with the provider array, which imports every interceptor class.
const skipList: string[] = ['oauth2/token', 'accept-invitation', '3motionai', 'myastgprodp.blob.core.windows.net'];

export function inSkipList(url: string): boolean {
  return skipList.some((s) => url.toLowerCase().includes(s.toLowerCase()));
}
